@if (expiringDocuments.length) {
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Hiányzó dokumentumok
        </mat-panel-title>
        <mat-panel-description>
          {{expiringDocuments.length}} kutyának hiányosak a dokumentumai
        </mat-panel-description>
      </mat-expansion-panel-header>
      @for (doc of expiringDocuments; track doc) {
        <div class="expiring-doc-div">
          <h4>
            {{getDogName(doc.dogId)}}
            <span class="header-description">- {{getDogHandlerDetails(doc.dogId)}}</span>
            <button mat-icon-button [routerLink]="['/dog', 'documents', {dogId: doc.dogId, dogName: getDogName(doc.dogId)}]"
              matTooltip="Ugrás a dokumentumokhoz/iratokhoz">
              <mat-icon>folder</mat-icon>
            </button>
          </h4>
          <ul>
            @for (e of doc.docs; track e) {
              <li>
                <strong>{{getDocName(e.missingDocumentType)}}</strong> -
                @if (e.expiryDate) {
                  Lejárat {{ e.expiryDate | date:'mediumDate'}}
                }
                @if (!e.expiryDate) {
                  Nincs dokumentum feltöltve
                }
              </li>
            }
          </ul>
        </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
}
